import script from "./whyIlearndSection.vue?vue&type=script&setup=true&lang=js"
export * from "./whyIlearndSection.vue?vue&type=script&setup=true&lang=js"

import "./whyIlearndSection.vue?vue&type=style&index=0&id=dfd79f94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd79f94"]])

export default __exports__